module.exports = require("mux.js/lib/tools/parse-sidx");